export default __webpack_public_path__ + "static/media/Phishing.226cefe1.jpg";